import { CollectionType } from '../../../../data-layer/collections/service';
import { TabsValue } from '../constants';

export const buildBloggerTabs = (businessId: string) => {
    if (!businessId) {
        return [];
    }

    return [
        {
            value: TabsValue.POSTS,
            link: `/profile/${businessId}`,
            label: 'Посты',
        },
        {
            value: TabsValue.COLLECTIONS,
            link: `/profile/${businessId}/collections`,
            label: 'Коллекции',
        },
    ];
};

export const buildSubcategories = (businessId: string, tabsValue: TabsValue) => {
    if (!businessId) {
        return [];
    }

    if (tabsValue === TabsValue.COLLECTIONS) {
        return [
            {
                value: CollectionType.CREATED,
                link: `/profile/${businessId}/collections`,
                label: 'Созданные',
            },
            {
                value: CollectionType.SAVED,
                link: `/profile/${businessId}/collections?collectionType=saved`,
                label: 'Сохраненные',
            },
        ];
    }

    if (tabsValue === TabsValue.POSTS) {
        return [
            {
                value: TabsValue.POSTS,
                link: `/profile/${businessId}`,
                label: 'Опубликованные посты',
            },
            {
                value: TabsValue.MODERATION,
                link: `/profile/${businessId}/moderation`,
                label: 'Все посты',
            },
        ];
    }

    return [];
};
